import request from '@/utils/seftRequest';

export function qryIPInfoBsnl(params) {
  return request('/ding/subsService/qryIPInfoBsnl', {
    method: 'POST',
    body: params,
  });
}

export function setVasBsnl(params) {
  return request('/ding/subsService/setVasBsnl', {
    method: 'POST',
    body: params,
  });
}

// 管理订户IP实例
export function manageSubsIPBsnl(params) {
  return request('/ding/subsService/manageSubsIPBsnl', {
    method: 'POST',
    body: params,
  });
}

// 查询属性信息接口
export function qryAttrInfoBsnl(params) {
  return request('/ding/custService/qryAttrInfoBsnl', { params });
}
